<!--添加订单  -->
<template>
	<div class="dialogBox">
		<el-dialog
			title="添加订单"
			v-if="dialogVisible"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			width="700px"
			:before-close="cancle"
		>
			<div class="mt20">
				<el-form
					:inline="true"
					:model="ruleForm"
					:rules="rules"
					ref="ruleForm"
					label-width="90px"
					class="demo-ruleForm"
				>
					<el-form-item label="SKU" prop="skuId">
						<el-select
							v-model.trim="ruleForm.skuId"
							class="w225"
							placeholder="请选择SKU"
						>
							<el-option
								v-for="item in skuList"
								:key="item.skuId"
								:label="item.skuName"
								:value="item.skuId"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="数量" prop="productQuantity">
						<el-input
							v-model.trim="ruleForm.productQuantity"
							maxlength="6"
							class="w225"
						></el-input>
					</el-form-item>
					<el-form-item label="出货仓" prop="storeCode">
						<el-select
							v-model.trim="ruleForm.storeCode"
							class="w225"
							placeholder="请选择出货仓"
						>
							<el-option
								v-for="item in storeList"
								:key="item.storeCode"
								:label="item.storeName"
								:value="item.storeCode"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="生产日期" prop="productDate">
						<el-date-picker
							type="date"
							value-format="yyyy-MM-dd"
							:editable="false"
							:picker-options="pickerOptions"
							placeholder="选择日期"
							v-model.trim="ruleForm.productDate"
							class="w225"
						></el-date-picker>
					</el-form-item>
				</el-form>
			</div>

			<span slot="footer" class="dialog-footer mt10">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { debounce } from "@/utils/debounce";
export default {
	data() {
		return {
			dialogVisible: false,
			ruleForm: {
				skuId: "",
				skuName: "",
				skuPrice: "",
				productQuantity: null,
				saleMoney: null,
				productDate: "",
				agentId: "",
				storeCode: ""
			},
			rules: {
				productQuantity: [
					{
						required: true,
						message: "请输入数量"
					},
					{
						pattern: /^[1-9]\d*$/,
						message: "请输入正整数"
					}
				],
				productDate: [
					{
						required: true,
						message: "请选择生产日期"
					}
				],
				skuId: [
					{
						required: true,
						message: "请选择SKU",
						trigger: "change"
					}
				],
				storeCode: [
					{
						required: true,
						message: "请选择出货仓"
					}
				]
			},
			skuList: [],
			storeList: [],
			settlementType: "",
			pickerOptions: {
				disabledDate(time) {
					return (
						time.getTime() > Date.now() - 1 * 24 * 60 * 60 * 1000 ||
						time.getTime() < Date.now() - 30 * 24 * 60 * 60 * 1000
					);
				}
			}
		};
	},
	created() {},
	methods: {
		init(data) {
			this.$nextTick(() => {
				this.dialogVisible = true;
				this.ruleForm = {
					skuId: "",
					skuPrice: "",
					productQuantity: null,
					saleMoney: null,
					productDate: "",
					agentId: "",
					storeCode: "",
					storeName: ""
				};
				if (data) {
					console.log(data)
					this.ruleForm.agentId = data.agentId;
					this.settlementType = data.settlementType;
					this.getOrderSku(data.agentId, data.groupId);
					this.getStoreList(data.groupId);
				}
			});
		},
		// 查询
		getOrderSku(agentId, groupId) {
			let that = this;
			that.$request
				.post("orderSku", true, {
					agentId: agentId,
					groupId: groupId
				})
				.then(res => {
					if (res) {
						that.skuList = res.data;
					}
				});
		},
		getStoreList(groupId) {
			let that = this;
			that.$request
				.post("getStores", true, {
					groupId: groupId
				})
				.then(res => {
					if (res) {
						that.storeList = res.data;
					}
				});
		},
		// 保存
		submitForm: debounce(
			function() {
				let that = this;
				that.$refs["ruleForm"].validate(valid => {
					if (valid) {
						const sku = that.skuList.find(obj => obj.skuId == that.ruleForm.skuId);
						if(that.ruleForm.productQuantity % sku.format === 0) {
							// 结算方式(NC)0：现金；1：账期；2：其它
							that.ruleForm.skuName = sku.skuName;
							// 整包现金价
							if (that.settlementType == 0) {
								that.ruleForm.skuPrice = sku.cashPrice;
								// 2.24*5=11.200000000000001解决办法
								const multiplier = 1000;
								// 整包总价
								that.ruleForm.saleMoney = ((sku.cashPacketPrice * multiplier) * (that.ruleForm.productQuantity / sku.format)) / multiplier;
							}
							// 整包账期价
							else if (that.settlementType == 1) {
								that.ruleForm.skuPrice = sku.accperiodPrice;
								// 2.24*5=11.200000000000001解决办法
								const multiplier = 1000;
								// 整包总价
								that.ruleForm.saleMoney = ((sku.accperiodPacketPrice * multiplier) * (that.ruleForm.productQuantity / sku.format)) / multiplier;
							}
							// 对应仓库名称
							that.storeList.forEach(item => {
								if (item.storeCode == that.ruleForm.storeCode) {
									that.ruleForm.storeName = item.storeName;
								}
							});
							that.ruleForm.uuid = new Date().getTime();
							that.$emit("rowData", that.ruleForm);
							that.dialogVisible = false;
						}else {
							that.$message.error(`数量请输入${sku.format}的倍数`);
						}
					} else {
						return false;
					}
				});
			},
			1000,
			true
		),
		// 取消
		cancle() {
			this.dialogVisible = false;
		}
	},
	beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.dialogBox {
	/deep/ .el-dialog__body {
		padding: 10px 20px;
	}

	/deep/ .el-radio .el-radio__label {
		display: none;
	}
}

.w225 {
	width: 225px;
}

.sort-box {
	justify-content: center;
	line-height: 40px;
	font-size: 16px;
}
</style>
